import {
  TuitionFeeHeadFee,
  TuitionFeeGroupHeadFee,
  TuitionFeeGroup,
  TuitionFeePrice,
  TuitionFeePeriod
} from '@/plugins/api'
import alert from '@/plugins/alert'
import { rangeRight, sortBy } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    headFees: [],
    headFee: {},
    oneHeadFee: {},
    groupHeadFee: null,
    tuitionGroups: [],
    pageText: '',
    router: '',
    itemsPerPage: 10,
    searchParams: {},
    totalItems: 0,
    loading: false,
    isSubFee: null
  },
  actions: {
    async fetchHeadFees(_, params) {
      try {
        let datas = await TuitionFeeHeadFee.fetch(params)
        return datas
      } catch (error) {
        alert.error('Đã có lỗi xảy ra: ' + error)
      }
    },
    async fetchHeadFee({ commit }, id) {
      commit('setHeadFee', await TuitionFeeHeadFee.fetchOne(id))
    },
    async fetchTuitionGroup({ commit }, payload) {
      commit('setTuitionGroup', await TuitionFeeGroup.fetch(payload))
    },
    async createHeadFees({ dispatch, commit }, payload) {
      try {
        let headFee = await TuitionFeeHeadFee.create(payload)
        dispatch('filterheadFee', { type: payload.type, id: headFee.id, isSubFee: `${headFee.isSubFee}` })
        commit('changeState', { oneHeadFee: headFee })
        alert.addSuccess()
      } catch {
        // alert.addError(error)
      }
    },
    async updateHeadFees({ dispatch, commit }, payload) {
      try {
        commit('updateHeadFees', await TuitionFeeHeadFee.update(payload.id, payload.data))
        dispatch('requestPageSettings', {})
        alert.updateSuccess()
      } catch {
        // alert.updateError(error)
      }
    },
    async deleteHeadFee({ dispatch }, payload) {
      await TuitionFeeHeadFee.remove(payload.id)
      dispatch('requestPageSettings', { type: payload.type })
    },
    async getGroupHeadFeeByHeadFee({ commit }, idHeadFee) {
      let groupHeadFees = await TuitionFeeGroupHeadFee.fetch({ _sort: 'createdAt:asc', head_fee: idHeadFee })
      groupHeadFees = sortBy(groupHeadFees, [
        function (o) {
          return o.createdAt
        }
      ])
      let periods = await TuitionFeePeriod.fetch()
      groupHeadFees.map(element => {
        if (element.prices.length > 0) {
          return element.prices.map(price => (price.period = periods[periods.findIndex(x => x.id === price.period)]))
        }
      })
      commit('setGroupHeadFee', await groupHeadFees)
    },
    async createGroupHeadFee({ dispatch, commit }, payload) {
      if (payload.period === 'month') {
        const result = await TuitionFeeGroupHeadFee.create(payload)
        dispatch('getGroupHeadFeeByHeadFee', payload.head_fee)
        commit('createGroupHeadFee', result)
        return result
      } else {
        const result = await TuitionFeeGroupHeadFee.create(payload)
        commit('createGroupHeadFee', result)
        return result
      }
    },
    async createPriceGroupHeadFee({ commit }, payload) {
      commit('updateGroupHeadFee', await TuitionFeeGroupHeadFee.createPrice(payload))
    },
    async deletePriceGroupHeadFee({ commit }, payload) {
      commit(
        'updateGroupHeadFee',
        await TuitionFeeGroupHeadFee.removePrice(payload.groupHeadFeeId, { priceId: payload.idPrice })
      )
    },
    async updatePriceGroupHeadFee({ commit }, payload) {
      let price = await TuitionFeePrice.update(payload.id, payload.price)
      payload.groupHeadFee = {
        ...payload.groupHeadFee,
        prices: payload.groupHeadFee.prices.map(item => (item.id === price.id ? price : item))
      }
      commit('updateGroupHeadFee', payload.groupHeadFee)
    },
    async deleteGroupHeadFee({ commit }, payload) {
      try {
        await TuitionFeeGroupHeadFee.remove(payload)
        commit('deleteGroupHeadFee', payload)
        alert.deleteSuccess()
      } catch (error) {
        alert.deleteError(error)
      }
    },
    async filterheadFee({ commit, state, dispatch }, query) {
      const searchParams = {
        ...query,
        _limit: state.itemsPerPage,
        category: query.category,
        type: query.type,
        isSubFee: query.isSubFee,
        head_fee_apply: query.head_fee_apply
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', { type: query.type, isSubFee: query.isSubFee })
    },
    async setSearchParam({ commit, state }) {
      const searchParams = {
        ...state.searchParams,
        type: 'priority'
      }
      commit('changeState', { searchParams })
    },
    setRouter({ commit }, payload) {
      switch (payload) {
        case 'head-fees':
          commit('changeState', { router: 'normal', isSubFee: false })
          break
        case 'deduction-head-fees':
          commit('changeState', { router: 'priority', isSubFee: false })
          break
        case 'arrear-fees':
          commit('changeState', { router: 'normal', isSubFee: true })
          break
        case 'refund-fees':
          commit('changeState', { router: 'priority', isSubFee: true })
          break
      }
    },
    async setType({ commit }, type) {
      if (type === 'arrear-fees') {
        commit('changeState', { router: 'normal', isSubFee: true })
      } else if (type === 'refund-fees') {
        commit('changeState', { router: 'priority', isSubFee: true })
      } else if (type === 'head-fees') {
        commit('changeState', { router: 'normal', isSubFee: false })
      } else {
        commit('changeState', { router: 'priority', isSubFee: false })
      }
    },
    clean({ commit }) {
      commit('clean')
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage, type, isSubFee = false }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'title:ASC',
          type: type,
          isSubFee: `${isSubFee}`
        }
        const [totalItems, headFees] = await Promise.all([
          TuitionFeeHeadFee.count(searchParams),
          TuitionFeeHeadFee.search(searchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            headFees,
            totalItems,
            itemsPerPage,
            searchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },
    async reset({ commit }) {
      commit('changeState', { groupHeadFee: null, headFee: {} })
    }
  },
  mutations: {
    setHeadFees(state, headFees) {
      state.headFees = headFees
    },
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    setHeadFee(state, headFee) {
      state.headFee = headFee
    },
    updateHeadFees(state, headFee) {
      state.headFee = headFee
    },
    setGroupHeadFee(state, groupHeadFee) {
      state.groupHeadFee = groupHeadFee
    },
    createGroupHeadFee(state, payload) {
      state.groupHeadFee.push(payload)
    },
    updateGroupHeadFee(state, payload) {
      state.groupHeadFee = state.groupHeadFee.map(item => (item.id === payload.id ? payload : item))
    },
    deleteGroupHeadFee(state, id) {
      state.groupHeadFee = state.groupHeadFee.filter(item => !(item.id === id))
    },
    setTuitionGroup(state, tuitionGroups) {
      state.tuitionGroups = tuitionGroups
    },
    clean(state) {
      state.headFees = []
      state.itemsPerPage = 10
      state.searchParams = {}
      state.totalItems = 0
    }
  }
}
